import script from "./EntityView2.vue?vue&type=script&setup=true&lang=js"
export * from "./EntityView2.vue?vue&type=script&setup=true&lang=js"

import "./EntityView2.vue?vue&type=style&index=0&id=068177dc&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-068177dc"]])

export default __exports__